import { IsString, MaxLength } from "class-validator";

export class ContactSearchDTO {
    
    @IsString()
    @MaxLength(50)
    name: string;

}
